import ActiveSingleJobWidgetProvider from './ActiveSingleJobWidgetProvider'
import ActiveSingleJob from './ActiveSingleJob'

export { ActiveSingleJob }
export default ActiveSingleJobWidgetProvider
